import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';

import HomeScreen from './home';
function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const { change, getInitData} = useRefresh();
    const [showDetailProduct, setShowDetailProduct] = useState(false);
     const [showListProduct, setShowListProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [showHome, setShowHome] = useState(false);
    const [menus, setMenus] = useState([]);
 const [valentine, setvalentine] = useState([]);
 const [datakarol, setdatakarol] = useState(false);
     const {
       goHomeInit
     } = useSelector((state) => state.initLoad);
    
    
       useEffect(() => {
      
    }, [change]);



    useEffect(() => {
    if (valentine) {
      valentine.map((item) => {
       
          if (item.id === 5494) {
          setdatakarol(item);
          }
         
      });
    }
    }, [valentine]);
    

     useEffect(() => {
            console.log(goHomeInit, 'q mas qlq')
              setShowHome(false)
     }, [goHomeInit]);
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
           setShowHome(false)
            getInitData()

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };
    

    return (
        <LayoutContent  showBack={false} showFooter={false} showLogo={false} showImageTop={false} setShowSpecials={() => {
            
        }} goCategories={null}>
            <div>
                <div style={{ width: '100%' }}>
                    <div onClick={() => {
                             setShowHome(true)
                        }}>
                        <img
                            loop
                            muted
                            autoPlay
                            style={{
                            marginTop: 100,
                            width: 600,
                            height: 750,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            borderRadius: 40
                            
                            
                        }}
                        src={require('./assets/home.png')}
                    />
                    </div>

                    <div
                        onClick={() => setShowHome(true)}
                        style={{
                            margin: "20px auto",
                            border: 'none',
                            cursor: 'pointer',
                        }}
                        >
                       <img src={require('./assets/seemenu.png')}  style={{objectFit: 'contain', width:250}}/>
                        </div>
                </div>
            </div>

            {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
            />}

             {showHome && <HomeScreen  />}
            
        </LayoutContent>
    );
}

export default Index;